
import { Asset, IObject } from '../interfaces';

export type SourceObject =  Asset | IObject;
